import React from "react";
import ContentCard from "./components/content-card.jsx";
import { AppHeading } from "../../layout/parts/app-heading.jsx";
import AppBody from "../../layout/parts/app-body.jsx";
import useApiRequest from "../../hooks/use-api-request.js";
import ImageWithFallback from "../../components/image-with-fallback.jsx";
import TabbedContent from "../../components/tabbed-content.jsx";
import SeriesTab from "./tabs/series-tab.jsx";
import SeasonsTab from "./tabs/seasons-tab.jsx";
import EpisodeListTab from "./tabs/episode-list-tab.jsx";
import ArtworkTab from "./tabs/artwork-tab.jsx";
import FilesTab from "./tabs/files-tab.jsx";
import PromosTab from "./tabs/promos-tab.jsx";
import { useParams } from "react-router-dom";

function SeriesPage() {
  const { series_guid } = useParams();
  const { isLoading, response: seriesSummaryRequest } = useApiRequest(`/api/series/${series_guid}/summary`);

  const breadcrumbs = [
    {
      link: "/content",
      title: "Content",
    },
    {
      link: "/content/library",
      title: "Library",
    },
    {
      title: seriesSummaryRequest?.data
        ? `${seriesSummaryRequest?.data.series_name} ${seriesSummaryRequest?.data.series_active ? "" : "(Inactive)"}`
        : "...",
      link: `/content/library/series/${series_guid}`,
    },
  ];

  return (
    <React.Fragment>
      <AppHeading breadcrumbs={breadcrumbs} />
      <AppBody loading={isLoading}>
        {!isLoading && (
          <div className="spread-container">
            <div className="spread-container__middle spread-container__middle--alone">
              <div className="content-page">
                <div className="content-page__media-row">
                  <div className="content-page__media-row__media">
                    <ContentCard noPadding>
                      <ImageWithFallback url={seriesSummaryRequest?.data?.poster} />
                    </ContentCard>
                  </div>
                  <div className="content-page__media-row__description">
                    <ContentCard>
                      <h1 className="content-page__title">{seriesSummaryRequest?.data?.series_name}</h1>
                      <h3 className="content-page__sub-title">Short Summary</h3>
                      <p className="content-page__text">{seriesSummaryRequest?.data?.summary?.short_summary}</p>
                      <h3 className="content-page__sub-title">Long Summary</h3>
                      <div className="content-page__text">{seriesSummaryRequest?.data?.summary?.long_summary}</div>
                    </ContentCard>
                  </div>
                </div>
                <div className="content-page__body">
                  <TabbedContent
                    tabs={[
                      {
                        label: "Series",
                        name: "series",
                        component: SeriesTab,
                        props: {
                          guid: series_guid,
                        },
                      },
                      {
                        label: "Seasons",
                        name: "seasons",
                        component: SeasonsTab,
                        props: { guid: series_guid },
                      },
                      {
                        label: "Episodes",
                        name: "episodes",
                        component: EpisodeListTab,
                        props: { guid: series_guid },
                      },
                      {
                        label: "Artwork",
                        name: "art",
                        component: ArtworkTab,
                        props: { guid: series_guid, type: "series" },
                      },
                      {
                        label: "Files",
                        name: "files",
                        component: FilesTab,
                        props: {
                          type: "series",
                          guid: series_guid,
                          folders: [
                            {
                              label: "Series",
                              url: `/api/series/${series_guid}/files/summary`,
                            },
                          ],
                        },
                      },
                      {
                        label: "Promos",
                        name: "promos",
                        component: PromosTab,
                        props: {
                          type: "series",
                          guid: series_guid,
                          groups: [
                            {
                              label: "Series",
                              url: `/api/series/${series_guid}/promos`,
                              contentGuid: series_guid,
                              type: "series",
                            },
                          ],
                        },
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </AppBody>
    </React.Fragment>
  );
}

export default SeriesPage;
